import { useLoading } from "../context/LoadingContext";

import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useProdutos } from "../context/ProdutosContext";
import "../css/EditarProdutos.css";

const EditarProdutos = () => {
  const navigate = useNavigate();
  const { 
    produtoEdit, 
    setProdutoEdit, 
    editarProduto, 
    deletarImagemProduto, 
    adicionarImagemProduto, 
    listarCategorias,
    categorias
  } = useProdutos();
  const { setIsLoading } = useLoading();
  
  const { id } = useParams();
  const [produto, setProduto] = useState(produtoEdit || {});
  const [imagem, setImagem] = useState(null);
  const [previewImagem, setPreviewImagem] = useState(produtoEdit?.imagem?.[0] || null);

  useEffect(() => {
    if (!produtoEdit) {
      navigate(`/${id}/cardapio`);
    } else {
      fetchCategorias();
    }
  }, [produtoEdit, id, navigate]);

  const fetchCategorias = async () => {
    const toastId = toast.loading("Carregando categorias...");
    setIsLoading(true);
    try {
      await listarCategorias(id);
      toast.update(toastId, {
        render: "Categorias carregadas com sucesso!",
        type: "success",
        isLoading: false,
        autoClose: 2000,
      });
    } catch (error) {
      toast.update(toastId, {
        render: "Erro ao carregar categorias.",
        type: "error",
        isLoading: false,
        autoClose: 3000,
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setProduto((prev) => ({ ...prev, [name]: value }));
    setProdutoEdit((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmitProduto = async (e) => {
    e.preventDefault();
    const toastId = toast.loading("Atualizando produto...");
    setIsLoading(true);
    try {
      const produtoAtualizado = {
        id: produto.id,
        nome: produto.nome,
        categorias: [{ id: produto.idCategoria }],
        preco: parseFloat(produto.preco),
        receita: produto.receita,
      };
      await editarProduto(id, produtoAtualizado);
      if (imagem) {
        if (produto.imagem?.[0]) {
          await deletarImagemProduto(id, produto.id);
        }
        await adicionarImagemProduto(id, produto.id, imagem);
      }

      toast.update(toastId, {
        render: "Produto atualizado com sucesso!",
        type: "success",
        isLoading: false,
        autoClose: 2000,
      });
      setProdutoEdit(null);
      navigate(`/${id}/cardapio`);
    } catch (error) {
      toast.update(toastId, {
        render: "Erro ao atualizar o produto. Tente novamente.",
        type: "error",
        isLoading: false,
        autoClose: 3000,
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmitProduto} className="produto-form">
      <ToastContainer />
      <h2>Editar Produto</h2>
      <div className="form-group">
        <label>Subcategoria</label>
        <input
          type="text"
          name="subCategory"
          value={produto?.subCategory || ""}
          onChange={handleChange}
          required
        />
      </div>
      <div className="form-group">
        <label>Nome do Produto</label>
        <input
          type="text"
          name="nome"
          value={produto?.nome || ""}
          onChange={handleChange}
          required
        />
      </div>
      <div className="form-group">
        <label>Categoria</label>
        <select
          name="idCategoria"
          value={produto?.idCategoria || ""}
          onChange={(e) =>
            setProduto((prev) => ({ ...prev, idCategoria: e.target.value }))
          }
          required
        >
          <option value="" disabled>Selecione uma categoria</option>
          {categorias.map((categoria) => (
            <option key={categoria.id} value={categoria.id}>
              {categoria.nome}
            </option>
          ))}
        </select>
      </div>
      <div className="form-group">
        <label>Preço</label>
        <input
          type="number"
          step="0.01"
          name="preco"
          value={produto?.preco || ""}
          onChange={handleChange}
          required
        />
      </div>
      <div className="form-group">
        <label>Descrição</label>
        <input
          type="text"
          name="descricao"
          value={produto?.descricao?.[0] || ""}
          onChange={handleChange}
        />
      </div>
      <div className="form-group">
        <label>Receita</label>
        <input
          type="text"
          name="receita"
          value={produto?.receita || ""}
          onChange={handleChange}
        />
      </div>
      <div className="form-group">
        <label>Imagem</label>
        <input
          type="file"
          name="imagem"
          accept="image/*"
          onChange={(e) => {
            const file = e.target.files[0];
            setImagem(file);
            setPreviewImagem(file ? URL.createObjectURL(file) : null);
          }}
        />
      </div>
      {previewImagem && (
        <div className="image-preview">
          <h4>Pré-visualização da Imagem:</h4>
          <img src={previewImagem} alt="Pré-visualização" />
          <button
            type="button"
            onClick={() => {
              setImagem(null);
              setPreviewImagem(null);
            }}
          >
            Remover Imagem
          </button>
        </div>
      )}
      <button type="submit">Salvar Alterações</button>
    </form>
  );
};

export default EditarProdutos;